import { render, staticRenderFns } from "./VendorTileHorizontal.vue?vue&type=template&id=5b4bc254&"
import script from "./VendorTileHorizontal.vue?vue&type=script&lang=js&"
export * from "./VendorTileHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports